import {Refresh, ViewColumn, LibraryAdd} from '@mui/icons-material'
import {GridToolbarContainer, useGridApiContext} from '@mui/x-data-grid-pro'
import SellIcon from '@mui/icons-material/Sell'
import {AiOutlineCheckSquare} from 'react-icons/ai'
import {
  Tooltip,
  IconButton,
  Box,
  Checkbox,
  Menu,
  MenuItem,
  FormControlLabel,
  Typography,
  Select,
  FormControl,
  InputLabel,
  Button,
} from '@mui/material'
import {useState} from 'react'
import AddProtheseModal from '../AddProtheseModal'
import AddLeadModal from '../AddLeadModal'
import {ICompany} from '../../../center/reducers'
import {ToolbarInput} from '../../../../utils/ToolbarInput'
import {gammesList} from '../../constants'
import {prosthesisGammeName} from '../../../../utils/patientInfos'
import {companyIcons} from '../../../../utils/constants'
import {useSelector} from 'react-redux'
import {canAddModifyDeleteReference} from '../../../auth/selectors/authSelector'
import {ILeadConnection} from '../../reducers';

export type ToolbarProps = {
  title: string
  makers: ICompany[]
  getMakers: () => Promise<unknown>
  onRefresh: () => void
  setSearchText: React.Dispatch<React.SetStateAction<string>>
  searchText: string
  selectedMakerIds: number[]
  setSelectedMakerIds: (value: number[]) => void
  selectedGammes: string[]
  setSelectedGammes: (value: string[]) => void
  type: 'PROSTHESIS' | 'TRANSMITTER'|'LEAD'
  leadConnexions: ILeadConnection[]
}

export function Toolbar({
  title,
  makers,
  onRefresh,
  getMakers,
  setSearchText,
  searchText,
  selectedMakerIds,
  setSelectedMakerIds,
  setSelectedGammes,
  selectedGammes,
    type,
                          leadConnexions
}: ToolbarProps) {
  const apiRef = useGridApiContext()
  
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [isAddProtheseOpen, setIsAddProtheseOpen] = useState(false)
  
  const open = Boolean(anchorEl)
  const columns = apiRef.current.getAllColumns()
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  
  const openModal = () => {
    setIsAddProtheseOpen(true)
  }
  
  const handleHide = (event: React.MouseEvent<any>) => {
    const column = columns.find(
        (column) => column.field === event.currentTarget.id,
    )
    if (column) apiRef.current.setColumnVisibility(column.field, !!column.hide)
  }
  
  const resetAllFilter = () => {
    setSelectedGammes([])
    setSelectedMakerIds([])
    setSearchText('')
  }
  const currentFilter =
      selectedGammes?.length > 0 ||
      selectedMakerIds?.length > 0 ||
      searchText?.length > 0
  
  const canManageProthesis = useSelector(canAddModifyDeleteReference)
  
  return (
      <GridToolbarContainer
          sx={{
            background: 'linear-gradient(60deg, #84c2ce, #96dcea)',
            borderRadius: '0px 15px 0px 0px',
          }}
      >
        {isAddProtheseOpen && type === 'PROSTHESIS' && (
            <AddProtheseModal
                getMakers={getMakers}
                isOpen={isAddProtheseOpen}
                handleClose={() => setIsAddProtheseOpen(false)}
            />
        )}
        {isAddProtheseOpen && type === 'LEAD' && (
            <AddLeadModal
                isOpen={isAddProtheseOpen}
                handleClose={() => setIsAddProtheseOpen(false)}
                leadReferenceConnexions={leadConnexions}
            />
        )}
        <Box
            ml={2}
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            sx={{pr: 10}}
        >
          <SellIcon
              sx={{
                marginRight: '1rem',
                padding: '0px 10px 0px 0px',
                color: 'white',
                width: '10% ',
                height: '10%',
              }}
          />
          
          <Typography
              variant="h5"
              color="primary"
              sx={{fontWeight: 'bold', color: 'white'}}
          >
            {title}
          </Typography>
        </Box>
        
        <Box sx={{flexGrow: 1}}/>
        {/* <GridToolbarDensitySelector /> */}
        {/* <GridToolbarExport /> */}
        {/* <GridToolbarFilterButton /> */}
        {currentFilter && (
            <Tooltip title={'Filtrer'}>
              <Button
                  variant="contained"
                  size="small"
                  color="error"
                  onClick={resetAllFilter}
              >
                Supprimer filtre(s)
              </Button>
            </Tooltip>
        )}
        {canManageProthesis && (type ==='PROSTHESIS' || type === 'LEAD') && (
            <Tooltip title={type === 'PROSTHESIS' ? 'Ajouter une référence de prothèse' : type === 'LEAD' ? 'Ajouter une référence de sonde' : ''}>
              <IconButton onClick={openModal}>
                <LibraryAdd/>
              </IconButton>
            </Tooltip>
        )}
        {type === 'PROSTHESIS' && (
            <FormControl sx={{m: 1}}>
              {!selectedGammes.length && (
                  <InputLabel
                      shrink={false}
                      sx={{
                        transform: 'translate(24px, 8px) scale(1)',
                      }}
                  >
                    Type de prothèse
                  </InputLabel>
              )}
              <Select
                  onChange={(ev) => setSelectedGammes(ev.target.value as string[])}
                  style={{
                    width: 200,
                    height: 40,
                    backgroundColor: '#B5E5F0',
                    borderWidth: 0,
                    borderColor: 'white !important',
                    marginRight: 6,
                    borderRadius: 8,
                    color: 'black',
                  }}
                  value={selectedGammes}
                  renderValue={(selected) => {
                    // Map the selected IDs to their corresponding names.
                    return selected
                        .map((gamme) => prosthesisGammeName(gamme))
                        .join(', ')
                  }}
                  multiple
              >
                {gammesList.map((gamme) => (
                    <MenuItem key={gamme.id} value={gamme.name}>
                      {selectedGammes.includes(gamme.name) && (
                          <AiOutlineCheckSquare
                              size={20}
                              style={{marginRight: '5px'}}
                          />
                      )}
                      {prosthesisGammeName(gamme.name)}
                    </MenuItem>
                ))}
              </Select>
            </FormControl>
        )}
        
        <FormControl sx={{m: 1}}>
          {!selectedMakerIds?.length && (
              <InputLabel
                  shrink={false}
                  sx={{
                    transform: 'translate(24px, 8px) scale(1)',
                  }}
              >
                Fabricant(s)
              </InputLabel>
          )}
          <Select
              multiple
              onChange={(ev) => setSelectedMakerIds(ev.target.value as number[])}
              style={{
                width: 200,
                height: 40,
                backgroundColor: '#B5E5F0',
                borderWidth: 0,
                borderColor: 'white !important',
                marginRight: 6,
                borderRadius: 8,
                color: 'black',
              }}
              value={selectedMakerIds}
              renderValue={(selected) => {
                // Map the selected IDs to their corresponding names.
                return selected
                    .map((id) => makers.find((maker) => maker.id === id)?.companyName)
                    .join(', ')
              }}
          >
            {makers.map((maker) => {
              return (
                  <MenuItem key={maker.id} value={maker.id}>
                    {selectedMakerIds.includes(maker.id) && (
                        <AiOutlineCheckSquare
                            size={20}
                            style={{marginRight: '5px'}}
                        />
                    )}
                    {companyIcons[maker.id]}
                  </MenuItem>
              )
            })}
          </Select>
        </FormControl>
        
        <ToolbarInput
            searchText={searchText}
            setSearchText={setSearchText}
            label="Rechercher un modèle / référence"
        />
        <Tooltip title={'Colonnes'}>
          <IconButton
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
          >
            <ViewColumn/>
          </IconButton>
        </Tooltip>
        
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
        >
          {columns.map((column, key) => (
              <MenuItem key={key} onClick={handleHide} id={column.field}>
                <FormControlLabel
                    control={<Checkbox checked={!column.hide}/>}
                    label={column.headerName as string}
                />
              </MenuItem>
          ))}
        </Menu>
        
        <Tooltip title={'Rafraîchir'}>
          <IconButton onClick={onRefresh}>
            <Refresh/>
          </IconButton>
        </Tooltip>
      </GridToolbarContainer>
  )
}
